export function isElementChildOf(c, p) {
  if (c === p) {
    return true;
  }

  let child = c;
  do {
    child = child.parentNode;
  }
  while (child && child !== p);

  return !!child;
}

export function getTextNodesIn(node, includeWhitespaceNodes) {
  const textNodes = [];
  const nonWhitespaceMatcher = /\S/;

  function getTextNodes(node) {
    if (node.nodeType === 3) {
      if (includeWhitespaceNodes || nonWhitespaceMatcher.test(node.nodeValue)) {
        textNodes.push(node);
      }
    } else {
      for (let i = 0, len = node.childNodes.length; i < len; ++i) {
        getTextNodes(node.childNodes[i]);
      }
    }
  }

  getTextNodes(node);
  return textNodes;
}

export function injectHtml(parentElement, htmlText) {
  const range = document.createRange();
  range.selectNode(parentElement);
  const fragment = range.createContextualFragment(htmlText);
  parentElement.appendChild(fragment);
}

function getClosestTop() {
  let frame = window;
  let error = false;

  try {
    while (frame.parent.document !== frame.document) {
      if (frame.parent.document) {
        frame = frame.parent;
      } else {
        //chrome/ff set exception here
        error = true;
        break;
      }
    }
  } catch (e) {
    // Safari needs try/catch so sets exception here
    error = true;
  }

  return { topFrame: frame, error };
}

// get top window's URL form inside of multiple nested cross-domain iFrames
export function getTopWindowUrl() {
  const { error: crossDomainError, topFrame } = getClosestTop();
  let bestPageUrl = '';

  if (!crossDomainError) {
    // easy case- we can get top frame location
    bestPageUrl = topFrame.location.href;
  } else {
    try {
      try {
        // If friendly iframe
        bestPageUrl = window.top.location.href;
      } catch (e) {
        //If chrome use ancestor origin array
        const origins = window.location.ancestorOrigins;
        //Get last origin which is top-domain (not supported by FF and IE: https://developer.mozilla.org/en-US/docs/Web/API/Location/ancestorOrigins)
        bestPageUrl = origins[origins.length - 1];
      }
    } catch (e) {
      bestPageUrl = topFrame.document.referrer;
    }
  }
  return bestPageUrl;
}
